<template>
  <div class="membercon">
    <div class="back" @click="back">
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD/SURBVHgB7ZYxDoIwGEZ/rAfwCHoDEi6gmyNHYGTkCHoDR8LEEbyBusPgDXoEFxgYwHYgYcDkb/s1xsgboCWU9wZoIFr4dwICkmXZpmmaWAhxz/NcctasCYSWt217C4Ig7Pteqks7zroVARjlahiSIc4BM3LZdd2Bu97pHfgkL8tScp9hHYCQWweg5FYBSLlxAFpuFOBDrmF/hj7k7IA0TbcTOQ3DcEHINYJzU1VVryiK9HCvD2q7Paq5rOv6SY6wAjRK9phGKGJEBDvAV4RRgI8I4wB0hFUAMsI6ABXhFICIgPwRFUVxVqfTONcbFXctJGAm4krfIkmSDS0s/BJvesTNh0rytvIAAAAASUVORK5CYII="
        alt=""
      />
    </div>
    <div class="jilu" @click="jumppage()">交易明细</div>
    <div class="userdata">
      <div>
        <img :src="userdata.avatar" alt="" />
        <p class="name">{{ userdata.nickname }}</p>
        <p class="id">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAARCAYAAADHeGwwAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIDSURBVHgBjVRRbhNBDLV3lorP8IUQSCQnYHsCcoRAUgTip5yAcIKGG5Qb8IkIaHOE9AbJCbJA2+/9iYSSjN3Z2e7WdqKq/kjWY4/fGz/PIBi7mg5ZuOXzk99PGufvr+HAMeR2DyCUQFwwwnyb0rfem1nRhBKZ92866ks/IC2k75hfwSFj6ABihoDjo51bXU1Hk4MADk0B4oUmin14kPHZ5Y+34z0AYO6qggnPQSOoeOopY/bHgckAAVQuOjyLOaArZApvw3+a71U+6PBOADAvnr7Pl7feIsQvjrxbxXbV1qlark4Qet4Xbvni46xtUbpLFXggU0gvCFuGv5nKQH7ZAlzmJ5q9Fdjqg1qfeolLu9YCkKeuihiBzekgYaNPlYPY1YBUtgAp82vQlDVDMwD/17wEY0HoPQ2FBlpgR1Q035XAJl72Ps1UO6oWM6spixq2AOEWKoBn7/KL5tsKbPWJ9Dx9VgvMUfCkQRfjFUdQ5lqBEXT/r6ejcdh/Ktc2nr5GctVPJbBT8HoE2fQ2rEQCVeseeTdhZsv+e+9D/R5FgPqNQcFQ38qwIZPxMODn1z+H5+ri3eUWmzV9adzkdoNiiECmxzoeBOsy7hcPJ52H4sdyANK6IGTyjZYjGPXZEdxnVWHHNJGDoQE8TJoGUEJqBLewLR6TOz1U2KNfbtdQ2JGVdgPaL/I/rUgFmQAAAABJRU5ErkJggg=="
            alt=""
          />
          <span>{{ userdata.id }}</span>
        </p>
      </div>
      <!-- <div>
        您当前还未开通会员,剩余<span>{{ userdata.ai_drop }}</span>点数
      </div> -->
    </div>
    <el-scrollbar>
      <div class="memberbox">
        <div
          v-for="(item, index) in member"
          :key="index"
          :class="memberindex == index ? 'on' : ''"
          @click="clickVipItem(index)"
        >
          <div>
            <p class="name">{{ item.title }}</p>
			<div class="name">{{ item.content }}</div>
            <p class="price"><span>￥</span>{{Number(item.current_price)}}<span>{{item.unit}}</span></p>
            <p class="remake">{{ item.discount_prompt }}</p>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div class="package">
      <div>
        <p class="packagetitle">套餐详情</p>
        <div class="packagemsg">
          <div>
            <p class="p1">
              <img
                src="data:image/png;base64,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"
                alt=""
              />
              <span>{{website.web_title}}{{ memberdata.title }}</span>
            </p>
            <p class="p2">{{memberconfig.content}}</p>
          </div>
          <div>
            <p class="p3"><span>￥</span>{{Number(memberdata.current_price)}}</p>
            <p class="p4"><span>￥</span>{{Number(memberdata.original_price)}}</p>
          </div>
        </div>
        <div class="packagelist" v-for="(item,index) in memberconfig.list" :key="index">
          <p v-for="(list,i) in item.list" :key="i">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEGSURBVHgB7dRBDsFAFAbgfyaCpSNMnKALEkuWbMQRHMEJcAJH4AZWYll7Ek5Aj2AlKYlnRky0NSUx01X7b9q+eZMveekMUKRIrtNeilpzJbxojSOjKOxSYT4Y96NoJuAbYx5jqIGzmV4rwXGi2LNAdLiFNNDrDA5jwq4hdQ6D4Kx7nI00iRFok8RUnIz0E8Ni2z0NTb3WIzVjx2FaP09uRoZYDGythbhU+b6xrk+QERYDCWwuH0IWxr/Qf7EYGILUhuBVTEVtMJXYT+PJsZbBffkq1PcdmO66x4kr7AP8hrrAjGAayon6tlgqaEJ1bLCvoAm1xX6CGq3II3OXF/G2F4xQJPd5APatnNEQgyvuAAAAAElFTkSuQmCC"
              alt=""
            />
            <span>{{list.content}}</span>
          </p>
        </div>
      </div>
    </div>
	<div class="equity">
	  <p class="equitytitle">会员权益</p>
	  <div class="table-box">
	    <table class="pri-table" border="0">
	      <thead>
	        <tr>
	          <th scope="col" class="fix-left">会员权益</th>
	          <th v-if="member.length > 2" :class="['scroll-th','th2',memberindex2==0?'bg-head':'']" scope="col">体验会员</th>
	          <th :class="['scroll-th','th3',memberindex2==1?'bg-head':'']" scope="col">包月会员</th>
	          <th :class="['scroll-th','th4',memberindex2==2?'bg-head':'']" scope="col">包年会员</th>
	        </tr>
	      </thead>
	      <tbody>
			<tr>
			  <td class="fix-left">
				<div class="group-item-title">
				  <span>快速克隆</span>
				</div>
			  </td>
			  <td v-if="member.length > 2" :class="['scroll-td','td2',memberindex2==0?'active':'']">
				<span>无限制</span>
			  </td>
			  <td :class="['scroll-td','td3',memberindex2==1?'active':'']">
				<span>无限制</span>
			  </td>
			  <td :class="['scroll-td','td4',memberindex2==2?'active':'']">
				<span>无限制</span>
			  </td>
			</tr>
			<tr>
			  <td class="fix-left">
				<div class="group-item-title">
				  <span>声音复刻</span>
				</div>
			  </td>
			  <td v-if="member.length > 2" :class="['scroll-td','td2',memberindex2==0?'active':'']">
				<span>无限制</span>
			  </td>
			  <td :class="['scroll-td','td3',memberindex2==1?'active':'']">
				<span>无限制</span>
			  </td>
			  <td :class="['scroll-td','td4',memberindex2==2?'active':'']">
				<span>无限制</span>
			  </td>
			</tr>
			<tr>
			  <td class="fix-left">
				<div class="group-item-title">
				  <span>影视工厂</span>
				</div>
			  </td>
			  <td v-if="member.length > 2" :class="['scroll-td','td2',memberindex2==0?'active':'']">
				<span>{{member[0].content}}/{{member[0].unit}}</span>
			  </td>
			  <td :class="['scroll-td','td3',memberindex2==1?'active':'']">
				<span v-if="member.length > 2">{{member[1].content}}/{{member[1].unit}}</span>
				<span v-if="member.length == 2">{{member[0].content}}/{{member[0].unit}}</span>
			  </td>
			  <td :class="['scroll-td','td4',memberindex2==2?'active':'']">
				<span v-if="member.length > 2">{{member[2].content}}/{{member[2].unit}}</span>
				<span v-if="member.length == 2">{{member[1].content}}/{{member[1].unit}}</span>
			  </td>
			</tr>
	      </tbody>
	    </table>
	  </div>
	</div>
    <!-- <div class="equity">
      <p class="equitytitle">会员权益</p>
      <div class="table-box">
        <table class="pri-table" border="0">
          <thead>
            <tr>
              <th scope="col" class="fix-left">会员权益</th>
              <th :class="['scroll-th','th2',memberindex==0?'bg-head':'']" scope="col">标准会员</th>
              <th :class="['scroll-th','th3',memberindex==1?'bg-head':'']" scope="col">高级会员</th>
              <th :class="['scroll-th','th4',memberindex==2?'bg-head':'']" scope="col">旗舰会员</th>
            </tr>
          </thead>
          <tbody>
            <tr class="group-title-tr">
              <td class="fix-left">
                <div class="group-title">
                  <div class="title-bg"></div>
                  <span>Al文字创作</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']"></td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']"></td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']"></td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>创作次数</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>无限</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>无限</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>无限</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>VIP加速</span>
                  <div class="title-tip">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJlSURBVHgB1VXLUeNAEB3Z+HMkg9VmoM1ARLBsBMZVLn/KB8gAEcGyB5c/5SrbGTgDRASrjWBFBlz95z3RI4ZBlsyRrhppNDPd/bpfT0upry5O3uZsNjtfrVYNx3F8fHoYrmzFWIsPh8N8v98/9nq9+FMOaHi9Xt9geo1xrorlrtPpBCc5GA6HbqlUetBogTIE2nm5XA5brdYT1waDgYczHD/xeSmqMaK5sKNxcowzDVftdvtR5YitYzt552A8Hv/nQRiOKpXKRbPZfNZ7o9GI6fISJccJkZKF3mNKN5vNA6LlflytVn9oXccwHuB1ax+wlN9Ct0AIb38lkgAA7rhe0mGKccUQTeQwHmhkGFeYk3xWkAeD1/ocdaDblM8bOkwdQHw+oLS0ScIaiVTb7fYX09Ltdv+Yhsyz0GVBhJgm5Z06QIU0JOylsoRE8x70+/3INCTTDyW82+0WJugzQekKyn+2QlYVgS+NPFIfJRRgXupASc2bKLOEhqHYMAi/t88wxTiX2jxTn5PfMM73M94B+FgUKWiSYz6m0+k3dYKgjL+T7Ky9yWTimTa1gyQ1IMhXOUKyOcwytgU2EgeIMOZbk8zyumTF4PNo2EVtI0H82p8IZp5GUKvVaJR59XHp/GPKvO0Yt8f25cImzY9tPHUgId8Lgpm+hZayr15ve8Buau9TR5oeJdAXVnNA4kgaF132HttJvV6PJOylXc66XynpqLoPUXLbdVZ/z4qMUatT2nWGEwrbx5K3XCOXXPtsMeRNzhX/cEwRMgNVLAl/THFW+eb+9DVStgcMzl2NFiNiebMC8+7FC0/sYYMxf9BZAAAAAElFTkSuQmCC"
                    />
                  </div>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>100次/天</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>200次/天</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>300次/天</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>结果优化</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
            </tr>
            <tr class="group-title-tr">
              <td class="fix-left">
                <div class="group-title">
                  <div class="title-bg"></div>
                  <span>文生视频</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']"></td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']"></td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']"></td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>普通模板</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>4次/天</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>4次/天</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>24次/天</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>自定义模板</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>1次/天</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>4次/天</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>6次/天</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>文案字数</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>400字/次</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>600字/次</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>1000字/次</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>清晰度</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>高清720P</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>超清1080P</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>超清1080P</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>照片换脸</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>5次/天</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>10次/天</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>20次/天</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>动态换脸</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD2SURBVHgB7ZRLEoIwDEDTWj2PXoef9STgSeQzcB08j5ZW4gwO0BQZdeGib0dIHikJAHg8f8xNyv0nOZxKvCdJxrVuVZIcwSWLY4k5mDuOM0rWB9NRSIqyLCwZY5fh2gCct2WZWUI8Aj4VbF7SuWxAK3XYNc3V6lD1BUAUoFQbwygZdJ0UdV1YHa6QwpLMKVwtnckWhW+lhAzhsIBeurnZkGFnh65pzrBWin0hI6V8tax/Z2DMiRDm4y9quthBsOdCtJRsGIBrUMNiTzp8brrWmUuGiKrK551iDdaCiy6K0v4YRoWh8+eAnWIO5sIa8Pi/yPF4PBQPhUWTzbklXBsAAAAASUVORK5CYII="
                  />
                </div>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>3次/天</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>5次/天</span>
              </td>
            </tr>
            <tr class="group-title-tr">
              <td class="fix-left">
                <div class="group-title">
                  <div class="title-bg"></div>
                  <span>照片数字人</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']"></td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']"></td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']"></td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>创作次数</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>5次/天</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>8次/天</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>20次/天</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>音频时长</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>40秒/次</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>90秒/次</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>180秒/次</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>文案字数</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>200字/次</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>400字/次</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>1000字/次</span>
              </td>
            </tr>
            <tr class="group-title-tr">
              <td class="fix-left">
                <div class="group-title">
                  <div class="title-bg"></div>
                  <span>AI换脸</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']"></td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']"></td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']"></td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>创作次数</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>10次/天</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>15次/天</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>30次/天</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>高级模板</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
            </tr>
            <tr class="group-title-tr">
              <td class="fix-left">
                <div class="group-title">
                  <div class="title-bg"></div>
                  <span>AI写真</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']"></td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']"></td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']"></td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>创作次数</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <span>5次/天</span>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <span>10次/天</span>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <span>20次/天</span>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>去水印</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
            </tr>
            <tr class="group-title-tr">
              <td class="fix-left">
                <div class="group-title">
                  <div class="title-bg"></div>
                  <span>作品用途</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']"></td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']"></td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']"></td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>个人使用</span>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td class="fix-left">
                <div class="group-item-title">
                  <span>商用盈利</span>
                  <div class="title-tip">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJlSURBVHgB1VXLUeNAEB3Z+HMkg9VmoM1ARLBsBMZVLn/KB8gAEcGyB5c/5SrbGTgDRASrjWBFBlz95z3RI4ZBlsyRrhppNDPd/bpfT0upry5O3uZsNjtfrVYNx3F8fHoYrmzFWIsPh8N8v98/9nq9+FMOaHi9Xt9geo1xrorlrtPpBCc5GA6HbqlUetBogTIE2nm5XA5brdYT1waDgYczHD/xeSmqMaK5sKNxcowzDVftdvtR5YitYzt552A8Hv/nQRiOKpXKRbPZfNZ7o9GI6fISJccJkZKF3mNKN5vNA6LlflytVn9oXccwHuB1ax+wlN9Ct0AIb38lkgAA7rhe0mGKccUQTeQwHmhkGFeYk3xWkAeD1/ocdaDblM8bOkwdQHw+oLS0ScIaiVTb7fYX09Ltdv+Yhsyz0GVBhJgm5Z06QIU0JOylsoRE8x70+/3INCTTDyW82+0WJugzQekKyn+2QlYVgS+NPFIfJRRgXupASc2bKLOEhqHYMAi/t88wxTiX2jxTn5PfMM73M94B+FgUKWiSYz6m0+k3dYKgjL+T7Ky9yWTimTa1gyQ1IMhXOUKyOcwytgU2EgeIMOZbk8zyumTF4PNo2EVtI0H82p8IZp5GUKvVaJR59XHp/GPKvO0Yt8f25cImzY9tPHUgId8Lgpm+hZayr15ve8Buau9TR5oeJdAXVnNA4kgaF132HttJvV6PJOylXc66XynpqLoPUXLbdVZ/z4qMUatT2nWGEwrbx5K3XCOXXPtsMeRNzhX/cEwRMgNVLAl/THFW+eb+9DVStgcMzl2NFiNiebMC8+7FC0/sYYMxf9BZAAAAAElFTkSuQmCC"
                    />
                  </div>
                </div>
              </td>
              <td :class="['scroll-td','td2',memberindex==0?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD2SURBVHgB7ZRLEoIwDEDTWj2PXoef9STgSeQzcB08j5ZW4gwO0BQZdeGib0dIHikJAHg8f8xNyv0nOZxKvCdJxrVuVZIcwSWLY4k5mDuOM0rWB9NRSIqyLCwZY5fh2gCct2WZWUI8Aj4VbF7SuWxAK3XYNc3V6lD1BUAUoFQbwygZdJ0UdV1YHa6QwpLMKVwtnckWhW+lhAzhsIBeurnZkGFnh65pzrBWin0hI6V8tax/Z2DMiRDm4y9quthBsOdCtJRsGIBrUMNiTzp8brrWmUuGiKrK551iDdaCiy6K0v4YRoWh8+eAnWIO5sIa8Pi/yPF4PBQPhUWTzbklXBsAAAAASUVORK5CYII="
                  />
                </div>
              </td>
              <td :class="['scroll-td','td3',memberindex==1?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD2SURBVHgB7ZRLEoIwDEDTWj2PXoef9STgSeQzcB08j5ZW4gwO0BQZdeGib0dIHikJAHg8f8xNyv0nOZxKvCdJxrVuVZIcwSWLY4k5mDuOM0rWB9NRSIqyLCwZY5fh2gCct2WZWUI8Aj4VbF7SuWxAK3XYNc3V6lD1BUAUoFQbwygZdJ0UdV1YHa6QwpLMKVwtnckWhW+lhAzhsIBeurnZkGFnh65pzrBWin0hI6V8tax/Z2DMiRDm4y9quthBsOdCtJRsGIBrUMNiTzp8brrWmUuGiKrK551iDdaCiy6K0v4YRoWh8+eAnWIO5sIa8Pi/yPF4PBQPhUWTzbklXBsAAAAASUVORK5CYII="
                  />
                </div>
              </td>
              <td :class="['scroll-td','td4',memberindex==2?'active':'']">
                <div class="status-icon-box">
                  <img
                    class="status-icon"
                    alt=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgB7dItDsIwFMDx94rBMY9pFq4AmSySO3AHjsBuAgZNUJULDgdHmMGjECS09JEM9tF1GxOY/s3apP2tTQrg8/nsRXIisjGDns1kGCtQyVSGG5oj9Igw81lncw2wHcCPlTEKQQeVK4s9DyLJOXTEzPnSB+h5ASToPmRnBZjUoS7sskhTzGMKWGKGPFvEzKKTWdQWo9nnhE9g4otRyPMnbYO9dxWvw80GFpc3aY0HRFg1YRWwHi1nx6jKs7nubsfxckT/El0xK+hG3VgtaEebMSdYRIG3wXw+3996AUT7hc4ZkMIxAAAAAElFTkSuQmCC"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <div class="problem">
        <div>
            <p class="problemtitle">会员权益</p>
            <el-collapse>
                <el-collapse-item v-for="(item,index) in problem" :key="index" :title="item.title">
                    <div>{{item.content}}</div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
    <div class="notes">
        <div>
            <p class="notestitle">购买须知</p>
            <div class="content">
                请您仔细阅读以下服务协议，您购买会员或增值服务即视为您已阅读并同意购买须知及服务协议 
                1. 会员可用于{{website.web_title}}网页端（电脑、手机），有效期自购买之日起计算。在有效期内您可以享受会员权益； 
                2. 会员每日享受文字创作加速生成服务，由于AI需要大量计算资源，每日加速生成额度用尽后，将会降级到普通队列。处在普通队列时，您仍享受免费文字创作权益，但不再享受创作加速权益，且创作频繁将会触发系统限制，需要等待几分钟后才能重新创作； 
                3.您应在法律法规的要求下合法使用{{website.web_title}}，如发现利用AI生成违规内容，我们有权直接封禁账号并呈交资料给相关监管部门； 
            </div>
            <p class="tip">点击查看<i class="el-icon-right"></i></p>
        </div>
    </div>
    <div class="bottom-fixed">
		<p v-if="order.pay_money == 0" style="margin-bottom: 10px;">已使用：{{order.coupon_title}}</p>
        <div class="payBtn" v-if="order.pay_money > 0" @click="pay()">立即支付￥<span>{{Number(order.pay_money)}}</span></div>
        <div class="payBtn" v-if="order.pay_money == 0" @click="exchange()">立即兑换</div>
        <p>
            <img data-v-9fd28d5d="" class="agreeBtn icon el-tooltip__trigger el-tooltip__trigger" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAITSURBVHgBvVdBUsJAEOxd1JNFxR9ETx7hBeoLhCofQPkByhcoLwA/YPEAL75AfAFUefGk/IAU5QkqiTObjawQyEo26QNsks107+xkZ0bAErNx30MNLRpeIEYDAj6NPf04oHtTujepSTkKl9HLSfMusLEr8iYQsU/EXRp2DEIbDBGiR0Km2EeAWrHEA83oohgGWkhgLUCv+pWGPtxgSiKusrwhM8gbjsmhbJFNZXsNYo3cL4HcxIYnhEHOUT4ukdwU0UxjYrUFHHDlkwPJdtynF8oD2vVfqBIhTnkrEg8YiipDcrZA6L2foXoE7IUDfbw6gzyq4/jsRo3nH0+7pno4jK95Cy7gmFwe1kG5IR+RuJQUhg04gEkeLeb4/nzOf4mSmqQfHwWRRR4t5/kvUkY9gEWGq5/fqn9leDF3Q57Ak1bTaD+ZQBERoSPyxAb4c8hBunJThAty5haz9/5YVTh5Sg3ylKggOXt2wkE4sZnLBKYnCpMzqISTIaI32/mmiMLkjDgepUcxJ6L/1HtuEOJE6rw8RPUYMrfUSh5RNahQ5T8lQJdIA1SHQVqWyT+KuLkoG7EqyXrp5a8AFQsRrkoVwbYjVZQGGwK0CJ7QLkVEQt5e7w22NyaSynPhqEhdrXy6/igzGWlPNOEmMAdsa1uPaNucctHagT2Ss4U+772b0wwhHh3brVpN7mzPIeMRlsK6Pf8BoTgVNRwxo1kAAAAASUVORK5CYII=">
            开通即同意<span @click="jumppage(1)">《服务协议》</span>和<span @click="jumppage(2)">《隐私政策》</span>
        </p>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-jsapi';
import {
  configRecharge,
  configVip,
  userInfo,
  orderCreate,
  payPay,
  orderQuery,
  exchange,
} from "@/api/user";
export default {
  data() {
    return {
      problem:[
        {
            title:"1. 标准会员、高级会员、旗舰会员的区别",
            content:" xxxxx会员体系全新改版，会员等级定位由高到低为：旗舰会员、高级会员、标准会员；高等级的会员包含了低等级会员的权益，并在此基础上额外增加了权益。旧版本会员（月度/年度会员）已下架，如果您已购买旧版本会员，在会员有效期内您仍可继续享受旧版本的会员权益，您也可以选择补差价升级到新版本会员 "
        },
        {
            title:"2. 我已是会员，升级更高版本会员如何收费？",
            content:"  如果您的会员时长不低于180天，那么您当前会员的剩余时长将全部升级为对应高版本会员的时长，您只需要补差价即可。例如，我的标准会员有效期还有200天，升级到高级会员后，我的高级会员有效期为200天，需要补的差价为：200/365 * (299-269) = 16元；如果会员时长不足180天，那么升级后的会员时长为365天，当前会员剩余时长将会按该会员的现价进行折算抵扣，您只需要支付抵扣后剩余的金额即可。 "
        },
        {
            title:"3. 会员订单如何开具发票",
            content:"  xxxxx支持为您开具电子发票，请联系客服并提供开票信息，我们将在3个工作日内为您开具 "
        },
        {
            title:"4. 会员到期后，会自动续费吗？",
            content:" 请放心，xxxxx的增值服务不会自动续费/扣费"
        },
      ],
      userdata: this.$store.userInfo,
      memberindex: 0,
      memberindex2: 0,
      memberdata: {},
      member: [],
	  website: this.$store.website,
      memberconfig:[],
	  order:{
		coupon_money:0,
		pay_money:0,
		coupon_title:'',
	  },
    };
  },
  mounted() {
    // userInfo().then((res) => {
    //   this.userdata = res.data;
    // });
    configRecharge().then((res) => {
      console.log(res);
    });
    configVip().then((res) => {
      this.member = res.data.list;
      this.memberdata = this.member[0];
      this.memberconfig = res.data.config;
	  if(this.member.length == 2) {
		  this.memberindex= 0;
		  this.memberindex2= 1;
	  }
      this.orderCreate();
	  this.problem.forEach((item) => {
		  item.content = item.content.replace('xxxxx', this.website.web_title);
	  })
    });
  },
  methods: {
	  exchange() {
	  	const loading1 = this.$loading({
	  		lock: true,
	  		text: '加载中....',
	  		spinner: 'el-icon-loading',
	  		background: 'rgba(0, 0, 0, 0.7)'
	  	});
	      exchange({id:this.order.id}).then(res => {
	  	  if(res.code == 0) {
	  		  this.$message({
	  			message: res.message,
	  			type: "success",
	  		  });
	  		 this.$router.push({ path: "/order"});
	  	  }else {
	  		  _this.$message({
	  			message: res.message,
	  			type: "error",
	  		  });
	  	  }
	  	  loading1.close();
	     });
	  },
    jumppage(index) {
      switch (index) {
        case 1:
          window.open(this.$store.website.serve_url)
          break;
        case 2:
          window.open(this.$store.website.privacy_url)
          break;
      }
    },
	clickVipItem(index) {
		this.memberindex = index;
		if(this.member.length > 2) {
			this.memberindex2 = index
		}else {
			this.memberindex2 = index + 1
		}
		console.log(this.member)
		this.memberdata = this.member[index];
		this.orderCreate()
	},
    pay(){
		this.payPay(this.order.id);
		// const loading = this.$loading({
		//   lock: true,
		//   text: 'Loading',
		//   spinner: 'el-icon-loading',
		//   background: 'rgba(0, 0, 0, 0.7)'
		// });
  //     let create = {
  //       type: "vip",
  //       id: this.memberdata.id,
  //     };
  //     orderCreate(create).then((res) => {
		// this.order = res.data;
		// loading.close();
  //       this.payPay(res.data.id);
  //     });
    },
	orderCreate() {
	  let create = {
	    type: "vip",
	    id: this.memberdata.id,
	  };
	  orderCreate(create).then((res) => {
		this.order = res.data;
	    // this.payPay(res.data.id);
	    // clearInterval(this.time);
	  });
	},
    payPay(id) {
		const loading = this.$loading({
		  lock: true,
		  text: 'Loading',
		  spinner: 'el-icon-loading',
		  background: 'rgba(0, 0, 0, 0.7)'
		});
      let pay = {
        id: id,
        pay_type: "mp",
      };
      payPay(pay).then((res) => {
		  loading.close();
        this.callWeChatPay(res.data)
      });
    },
    callWeChatPay(params) {
		let that = this;
        // 配置微信JSAPI
        wx.config({
            debug: false, // 开发模式下设置为true，生产模式下设置为false
            appId: params.appId,
            timestamp: params.timeStamp,
            nonceStr: params.nonceStr,
            signature: params.signature,
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
        });
        
        // 调起微信支付
        wx.ready(() => {
            wx.chooseWXPay({
                timestamp: params.timeStamp,
                nonceStr: params.nonceStr,
                package: params.package,
                signType: params.signType,
                paySign: params.paySign,
                success(res) {
					that.$message({
						message: '支付成功',
						type: "success",
					});
					userInfo().then(res=>{
					  this.$store.userInfo = res.data
					  that.$router.push({ path: '/'});
					});
                },
                fail(err) {
					that.$message({
						message: '支付失败' + err,
						type: "error",
					});
                }
            });
        });
    },
    back() {
      this.$router.back();
    },
    jumppage(){
       this.$router.push({ path: '/order' })
    },
  },
};
</script>

<style lang="less">
.membercon {
  background-repeat: no-repeat;
  background-image: url(../../assets/mobile/vip_head_bg-7023eb65.png);
  background-size: 100% auto;
  min-height: 100vh;
  background-color: #f4f5f7;
  padding-bottom: 120px;
  .back {
    position: fixed;
    z-index: 2;
    left: 20px;
    top: 20px;
    width: 24px;
    height: 24px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 12px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
    }
  }
  .jilu {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 72px;
    height: 26px;
    text-align: center;
    cursor: pointer;
    line-height: 26px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.75);
    background-repeat: no-repeat;
    background-image: url(../../assets/mobile/detail_btn_bg-86ab9b26.png);
    background-size: 100% 100%;
    z-index: 2;
  }
  .userdata {
    padding: 20px 20px 0 56px;
    div:nth-child(1) {
      display: flex;
      gap: 8px;
      align-items: center;
      > img {
        width: 20px;
        border-radius: 20px;
      }
      .name {
        color: #633c03;
        font-weight: 700;
        font-size: 10px;
        max-width: 82px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 6px;
      }
      .id {
        display: inline-block;
        background: rgba(255, 255, 255, 0.28);
        height: 16px;
        line-height: 16px;
        border-radius: 0 8px 8px 0;
        color: #5d3a06;
        // padding: 0 4px 0 16px;
        font-size: 10px;
        min-width: 40px;
        position: relative;
        margin-left: 6px;
        font-weight: 400;
        width: 82px;
        img {
          width: 12px;
          margin-right: 4px;
          margin-left: 4px;
        }
      }
    }
    div:nth-child(2) {
      font-size: 12px;
      color: #5d3a06;
      span {
        color: #557fff;
      }
    }
  }
  .el-scrollbar {
    // height: 136px;
    margin-top: 20px;
    width: 100%;
    .el-scrollbar__wrap {
      overflow-y: hidden;
    }
  }
  .memberbox {
    display: flex;
    width: 460px;
    gap: 8px;
    padding: 12px 15px 4px;
    > div {
      margin: 0 5px;
      display: inline-block;
      width: 124px;
      height: 136px;
      background: #ffffff;
      box-shadow: 0 2px 8px rgba(237, 191, 121, 0.1);
      border-radius: 8px;
      padding: 23px 0;
      text-align: center;
      cursor: pointer;
      position: relative;
      border: 2px solid #fff;
      .name {
        font-size: 14px;
        color: #333;
        font-weight: 700;
      }
      .price {
        color: #020713;
        font-size: 32px;
        font-weight: 700;
        span {
          font-size: 12px;
        }
      }
      .remake {
        color: #999;
        font-size: 12px;
      }
    }
    .on {
      border-color: #f67e29;
      background: linear-gradient(
          180deg,
          rgba(255, 242, 227, 0.2) 4.01%,
          rgba(255, 227, 204, 0.2) 100%
        ),
        #ffffff;
    }
  }
  .package {
    padding: 20px 20px;
    > div {
      padding: 16px;
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      .packagetitle {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 16px;
      }
      .packagemsg {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f1f1f1;
        margin-bottom: 20px;
        padding-bottom: 20px;
        img {
          width: 26px;
          margin-right: 4px;
        }
        .p1 {
          font-size: 16px;
          font-weight: 700;
        }
        .p2 {
          color: #999;
          font-size: 12px;
        }
        .p3 {
          font-weight: 700;
          font-size: 28px;
          color: #020713;
          span {
            font-size: 10px;
          }
        }
        .p4 {
          text-decoration: line-through;
          color: #999;
          font-size: 12px;
          font-weight: 400;
          text-align: right;
        }
      }

      .packagelist {
        p {
          margin-top: 12px;
        }
        img {
          width: 14px;
        }
        span {
          color: #333940;
          font-size: 12px;
          font-weight: 700;
          margin-left: 12px;
        }
      }
    }
  }

  .equity {
    padding: 0 20px 20px;
    .equitytitle {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 12px;
    }
    .table-box{
        border-radius: 12px;
        overflow: hidden;
        font-size: 12px;
        text-align: center;
        .title-tip{
            display: inline;
        }
        img{
            width: 12px;
        }
        tr,td,th{
            padding: 0;
            border: none;
        }
        td{
            background: #fbfbfb;
        }
        .pri-table{
            border-collapse: collapse;
            width: 100%;
        }
        thead{
            tr{
                height: 30px;
                background: #ededed;
                font-size: 11px;
                color: 333;
            }
        }
        .fix-left{
            background-color: #fff;
        }
        .group-title-tr {
            td{
                padding-top: 20px;
                font-weight: 700;
            }
            .group-title{
                display: inline-block;
                position: relative;
                .title-bg{
                    display: inline-block;
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 2px;
                    height: 6px;
                    background: linear-gradient(101.22deg,rgba(157,202,255,.4) 8.28%,rgba(96,134,255,.4) 89.64%);
                }
            }
        }
        .scroll-td{
            padding: 4px 0;
        }
        .active{
            font-weight: 700;
            color: #96594a;
            background: #fff2e7;
        }
        .bg-head{
            color: #96594a;
            background: linear-gradient(95.35deg,#ffecbd 8.71%,#ffcaaa 92.41%),linear-gradient(277.6deg,#494b6f 13.82%,#5c5d88 77.28%);
        }
    }
  }

    .problem{
        padding: 0 20px;
        >div{
            padding: 16px;
            width: 100%;
            background: #ffffff;
            border-radius: 8px;
            .problemtitle{
                font-size: 16px;
                font-weight: 700;
                margin-bottom: 12px;
            }
        }
    }
    .notes{
        margin-top: 20px;
        padding: 0 20px;
        >div{
            padding: 16px;
            width: 100%;
            background: #ffffff;
            border-radius: 8px;
            .notestitle{
                font-size: 16px;
                font-weight: 700;
                margin-bottom: 12px;
            }
            .content{
                font-size: 13px;
                color: #666;
            }
            .tip{
                margin-top: 12px;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #999;
                font-size: 13px;
            }
        }
    }
    .bottom-fixed{
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        width: 100%;
        padding: 16px 20px;
        .payBtn{
            width: 100%;
            height: 52px;
            font-weight: 700;
            text-align: center;
            background: linear-gradient(180deg,#fee4b6 0%,#fdcd79 112.8%,#f8d48c 175%);
            border-radius: 48px;
            color: #613f1a;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
                color: #ff6543;
            }
        }
        p{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            img{
                width: 18px;
            }
            font-size: 12px;
            color: #888889;
            span{
                color: #2d8af5;
            }
        }
    }
}
</style>